/**
 * AmenTee Popup - A/B Testing Email Capture
  * Store: AmenTee (Christian Apparel)
  * File: popup-am.js
 * Version: 2.0 - With Fullscreen Support
 */

(function() {
  'use strict';
  
  // ===== CONFIGURATION =====
  const CONFIG = {
    storeId: 'AmenTee',
    formSubmitUrl: 'https://app.podautomate.com/form/669fcd1f-ed58-4c95-b5ed-cec50a3c9035',
    analyticsUrl: 'https://script.google.com/macros/s/AKfycbzqSpmuFnfCSeVSo3jguIEPnGul15054Uy_nKhDyOzIuTFPVajhGSnrngldntOcEemc/exec',
    variantApiUrl: 'https://script.google.com/macros/s/AKfycbzqSpmuFnfCSeVSo3jguIEPnGul15054Uy_nKhDyOzIuTFPVajhGSnrngldntOcEemc/exec',
    
    abTesting: {
      enabled: true,
      minSessionsPerVariant: 500,
      optimizationMode: 'winner-only',
      epsilonValue: 0.2
    },
    
    // Define your test variants here
    variants: [
      {
        id: 'variant-a-control',
        name: 'Control - Modal Layout',
        weight: 1,
        config: {
          layoutType: 'modal', // 'modal' or 'fullscreen'
          
          // Modal layout images
          logoUrl: 'https://cdn.shopify.com/s/files/1/0686/4086/6351/files/Amentee_Logo.png',
          productImageUrl: 'https://cdn.shopify.com/s/files/1/0686/4086/6351/files/Popup_Optin.jpg',
          
          // Fullscreen layout images (only used if layoutType='fullscreen')
          backgroundImageDesktop: '',
          backgroundImageMobile: '',
          textMode: 'dark', // 'dark' (black text) or 'light' (white text) - for fullscreen
          
          // Step 1 Content & Colors
          step1Headline: 'Do You Want A Mystery Discount?',
          step1HeadlineColor: '', // Optional: e.g., '#FF0000' or 'red' - leave empty for default
          step1Subtext: '', // Optional additional text below headline
          step1SubtextColor: '', // Optional color for subtext
          
          // Step 2 Content & Colors
          step2Headline: 'Unlock Your Mystery Discount',
          step2HeadlineColor: '', // Optional headline color
          step2Text: '', // Optional text above the email form
          step2TextColor: '', // Optional color for step2Text
          step2Subtext: '', // Optional subtext below headline
          step2SubtextColor: '', // Optional color for subtext
          
          // Step 3 Content & Colors
          step3Headline: 'Your 15% Discount Code:  AMEN15 ',
          step3HeadlineColor: '', // Optional headline color
          step3Text: 'Your code is also sent to your inbox.',
          step3TextColor: '', // Optional text color
          step3SubText: "Haven't received a message within 5 minutes? Please check your spam box or promotions tab/folder.",
          step3SubTextColor: '', // Optional subtext color
          
          // Buttons
          buttonTexts: ['Yes Please!'],
          buttonColor: '', // Optional: e.g., '#4F46E5' - button background color
          buttonTextColor: '', // Optional: e.g., '#FFFFFF' - button text color
          buttonHoverColor: '', // Optional: hover state background color
          
          // Submit Button (Step 2)
          submitText: 'Claim My Mystery Discount',
          submitButtonColor: '', // Optional: submit button background (defaults to buttonColor if empty)
          submitButtonTextColor: '', // Optional: submit button text (defaults to buttonTextColor if empty)
          
          // Decline Link
          declineText: 'No thanks, I want to pay full price.',
          declineTextColor: '', // Optional: e.g., '#6B7280' - decline link color
          
          // Email Input
          emailPlaceholder: 'Enter Your Email Here',
          emailInputBorderColor: '', // Optional: email input border color
          emailInputTextColor: '', // Optional: email input text color
          
          // Teaser
          teaserText: '🎁 Mystery Discount',
          teaserBackgroundColor: '', // Optional: teaser background color
          teaserTextColor: '' // Optional: teaser text color
        }
      },
      {
        id: 'variant-b-fullscreen',
        name: 'Fullscreen Dark Background',
        weight: 1,
        config: {
          layoutType: 'fullscreen',
          logoUrl: 'https://cdn.shopify.com/s/files/1/0686/4086/6351/files/Amentee_Logo.png',
          productImageUrl: '', // Not used for fullscreen
          backgroundImageDesktop: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=1920',
          backgroundImageMobile: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=800',
          textMode: 'light', // White text on dark background
          
          // Custom Colors Example
          step1Headline: 'NEW YEAR SALE - 15% OFF',
          step1HeadlineColor: '#FFD700', // Gold headline
          step1Subtext: 'Who are you shopping for?',
          step1SubtextColor: '#FFA500', // Orange subtext
          
          step2Headline: 'Unlock Your Savings',
          step2HeadlineColor: '#FFD700',
          step2Text: '',
          step2TextColor: '#FFFFFF',
          step2Subtext: '',
          step2SubtextColor: '#E5E7EB',
          
          step3Headline: 'Check Your Inbox!',
          step3HeadlineColor: '#10B981', // Green for success
          step3Text: 'Your discount code is waiting for you.',
          step3TextColor: '#FFFFFF',
          step3SubText: "Can't find it? Check spam or promotions.",
          step3SubTextColor: '#9CA3AF',
          
          buttonTexts: [
            'MYSELF',
            'AS A GIFT',
            'SPECIAL OCCASSION',
            'JUST BROWSING'
          ],
          buttonColor: '#000000', // Purple buttons
          buttonTextColor: '#FFFFFF',
          buttonHoverColor: '#7C3AED',
          
          submitText: 'Yes, I want 15% OFF',
          submitButtonColor: '#000000', // Green submit
          submitButtonTextColor: '#FFFFFF',
          
          declineText: 'No, I would rather pay full price.',
          declineTextColor: '#9CA3AF', // Gray decline
          
          emailPlaceholder: 'Enter Your Email Address Here',
          emailInputBorderColor: '#8B5CF6', // Purple border
          emailInputTextColor: '#1F2937',
          
          teaserText: '🎁Get 15% OFF',
          teaserBackgroundColor: '#8B5CF6',
          teaserTextColor: '#FFFFFF'
        }
      },
      {
        id: 'variant-c-benefit',
        name: 'Benefit - Modal Layout',
        weight: 1,
        config: {
          layoutType: 'modal',
          logoUrl: 'https://cdn.shopify.com/s/files/1/0686/4086/6351/files/Amentee_Logo.png',
          productImageUrl: 'https://cdn.shopify.com/s/files/1/0686/4086/6351/files/Popup_Optin1.jpg',
          backgroundImageDesktop: '',
          backgroundImageMobile: '',
          textMode: 'dark',
          step1Headline: 'Which phrase resonates with you?',
          step1HeadlineColor: 'navy', // Gold headline
          step1Subtext: '',
          step2Headline: 'Unlock Your 15% Discount',
          step2Subtext: '',
          step3Headline: 'You\'re All Set!',
          step3Text: 'Check your email for your personal discount code and start saving.',
          step3SubText: "Email not there? Look in spam or promotions.",
          buttonTexts: [
            'Be The Light.',
            'Faith Over Fear', 
            'Walking By Faith.', 
            'Made For More.'
        ],
          submitText: 'Yes, 15% OFF',
          declineText: 'No, Thanks...',
          emailPlaceholder: 'Enter Email Address Here',
          teaserText: '🎁Get 15% OFF'
        }
      },
    ],
    
    delaySeconds: 6,
    showOnce: true,
    exitIntent: true,
    scrollPercent: 60,
    suppressForLoggedInCustomers: true,
    accountCheckTimeoutMs: 2000,
    
    // TEST MODE: Show clickable teasers for all variants
    // Perfect for design testing and variant comparison
    // Set to true to see all variants as teasers at bottom of page
    // Click any teaser to preview that variant instantly
    testMode: true, // Set to true for testing, false for production
    
    // Excluded Pages (BLACKLIST) - Popup will NOT show on these pages
    // Only used when includedPages is empty
    excludedPages: [
      '/cart',
      '/checkout',
      '/account',
      '/account/login',
      '/account/register',
    ],
    
    // Included Pages (WHITELIST) - Popup ONLY shows on these pages
    // If this array has values, it overrides excludedPages
    // Perfect for testing on specific pages!
    // Examples:
    //   ['/pages/contact'] - Only show on contact page
    //   ['/pages/test', '/collections/sale'] - Show on test page and sale collection
    //   [] - Use excludedPages instead (normal mode)
    includedPages: [
      // Add pages here for testing mode
      '/policies/privacy-policy',
    ]
  };

  const storageKey = 'amentee_popup_shown';
  const completedKey = 'amentee_form_completed';
  const forcePopupKey = 'amentee_force_popup';
  const sessionIdKey = 'amentee_session_id';
  const humanVerifiedKey = 'amentee_human_verified';
  const variantIdKey = 'amentee_variant_id';
  const storage = CONFIG.showOnce ? localStorage : sessionStorage;

  function detectBot() {
    if (navigator.webdriver) return true;
    if (/HeadlessChrome/i.test(navigator.userAgent)) return true;
    if (window.document.documentElement.getAttribute('webdriver')) return true;
    if (window.callPhantom || window._phantom) return true;
    if (window.Buffer) return true;
    if (!navigator.languages || navigator.languages.length === 0) return true;
    const ua = navigator.userAgent;
    if (!ua || ua.length < 50) return true;
    if (!/Mozilla/i.test(ua)) return true;
    return false;
  }

  function getBotIndicators() {
    return {
      is_bot: detectBot(),
      webdriver: !!navigator.webdriver,
      headless: /HeadlessChrome/i.test(navigator.userAgent),
      languages: navigator.languages ? navigator.languages.length : 0,
      plugins: navigator.plugins ? navigator.plugins.length : 0,
      ua_length: navigator.userAgent.length
    };
  }

  function generateSessionId() {
    return 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  function getSessionId() {
    let sessionId = sessionStorage.getItem(sessionIdKey);
    if (!sessionId) {
      sessionId = generateSessionId();
      sessionStorage.setItem(sessionIdKey, sessionId);
    }
    return sessionId;
  }

  let hasInteracted = false;
  let mouseMovements = 0;
  
  function trackHumanInteraction() {
    if (!hasInteracted) {
      hasInteracted = true;
      sessionStorage.setItem(humanVerifiedKey, 'true');
    }
  }
  
  document.addEventListener('mousemove', () => {
    mouseMovements++;
    if (mouseMovements > 3) {
      trackHumanInteraction();
    }
  }, { passive: true, once: false });
  
  document.addEventListener('click', trackHumanInteraction, { passive: true });
  document.addEventListener('touchstart', trackHumanInteraction, { passive: true });

  async function trackEvent(eventType, additionalData = {}) {
    if (!CONFIG.analyticsUrl) return;
    
    const botIndicators = getBotIndicators();
    if (botIndicators.is_bot) {
      console.log('Bot detected, skipping analytics');
      return;
    }
    
    if (['popup_impression', 'form_submission'].includes(eventType)) {
      const isVerifiedHuman = sessionStorage.getItem(humanVerifiedKey) === 'true';
      if (!isVerifiedHuman && mouseMovements < 2) {
        console.log('Insufficient human interaction, skipping analytics');
        return;
      }
    }
    
    const eventData = {
      store_id: CONFIG.storeId,
      timestamp: new Date().toISOString(),
      event_type: eventType,
      url: window.location.href,
      referrer: document.referrer || 'direct',
      user_agent: navigator.userAgent,
      session_id: getSessionId(),
      variant_id: sessionStorage.getItem(variantIdKey) || 'unknown',
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...botIndicators,
      mouse_movements: mouseMovements,
      ...additionalData
    };

    try {
      await fetch(CONFIG.analyticsUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eventData),
        mode: 'no-cors'
      });
    } catch (error) {
      console.error('Analytics tracking error:', error);
    }
  }

  async function getEligibleVariants() {
    if (!CONFIG.abTesting.enabled) {
      return CONFIG.variants;
    }

    try {
      const response = await fetch(
        `${CONFIG.variantApiUrl}?action=get_variants&store_id=${CONFIG.storeId}`,
        {
          method: 'GET',
          cache: 'no-store'
        }
      );

      if (response.ok) {
        const data = await response.json();
        
        if (data.eligible_variants && data.eligible_variants.length > 0) {
          const eligibleIds = data.eligible_variants.map(v => v.variant_id);
          return CONFIG.variants.filter(v => eligibleIds.includes(v.id));
        }
      }
    } catch (error) {
      console.log('Variant API error, using all variants:', error);
    }

    return CONFIG.variants;
  }

  function selectVariant(eligibleVariants) {
    const existingVariantId = sessionStorage.getItem(variantIdKey);
    if (existingVariantId) {
      const existing = eligibleVariants.find(v => v.id === existingVariantId);
      if (existing) return existing;
    }

    const totalWeight = eligibleVariants.reduce((sum, v) => sum + (v.weight || 1), 0);
    let random = Math.random() * totalWeight;
    
    for (const variant of eligibleVariants) {
      random -= (variant.weight || 1);
      if (random <= 0) {
        sessionStorage.setItem(variantIdKey, variant.id);
        return variant;
      }
    }

    const fallback = eligibleVariants[0];
    sessionStorage.setItem(variantIdKey, fallback.id);
    return fallback;
  }

  function getVariantFast() {
    const cachedVariantId = sessionStorage.getItem(variantIdKey);
    if (cachedVariantId) {
      const variant = CONFIG.variants.find(v => v.id === cachedVariantId);
      if (variant) {
        return variant;
      }
    }
    return null;
  }

  const style = document.createElement('style');
  style.textContent = `
    /* ===== MODAL LAYOUT (EXISTING) ===== */
    .amentee-popup-overlay {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.75);
      z-index: 999999;
      justify-content: center;
      align-items: center;
      animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    .amentee-popup-overlay.active {
      display: flex;
    }

    /* Modal Layout */
    .amentee-popup.layout-modal {
      background: white;
      width: 820px;
      height: 540px;
      display: flex;
      border-radius: 0;
      overflow: hidden;
      position: relative;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    }

    .amentee-popup.layout-modal .amentee-popup-image {
      width: 300px !important;
      height: 540px !important;
      flex-shrink: 0;
      background-size: cover !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      display: block !important;
    }

    .amentee-popup.layout-modal .amentee-popup-content {
      flex: 1;
      padding: 60px 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      background: white;
    }

    /* ===== FULLSCREEN LAYOUT (NEW) ===== */
    .amentee-popup.layout-fullscreen {
      width: 100vw;
      height: 100vh;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      overflow-y: auto;
    }

    .amentee-popup.layout-fullscreen::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 0;
    }

    /* Close button for fullscreen */
    .amentee-popup-close {
      display: none;
      position: absolute;
      top: 20px;
      right: 20px;
      width: 44px;
      height: 44px;
      background: rgba(0, 0, 0, 0.5);
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-radius: 50%;
      cursor: pointer;
      z-index: 10;
      transition: all 0.2s;
      justify-content: center;
      align-items: center;
    }

    .amentee-popup.layout-fullscreen .amentee-popup-close {
      display: flex;
    }

    .amentee-popup-close:hover {
      background: rgba(0, 0, 0, 0.7);
      transform: scale(1.1);
      border-color: rgba(255, 255, 255, 0.6);
    }

    .amentee-popup-close::before,
    .amentee-popup-close::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 2px;
      background: #ffffff;
    }

    .amentee-popup-close::before {
      transform: rotate(45deg);
    }

    .amentee-popup-close::after {
      transform: rotate(-45deg);
    }

    /* Text mode variations for close button */
    .amentee-popup.layout-fullscreen.text-light .amentee-popup-close {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.4);
    }

    .amentee-popup.layout-fullscreen.text-light .amentee-popup-close:hover {
      background: rgba(255, 255, 255, 0.25);
      border-color: rgba(255, 255, 255, 0.7);
    }

    .amentee-popup.layout-fullscreen.text-dark .amentee-popup-close {
      background: rgba(0, 0, 0, 0.15);
      border-color: rgba(0, 0, 0, 0.3);
    }

    .amentee-popup.layout-fullscreen.text-dark .amentee-popup-close:hover {
      background: rgba(0, 0, 0, 0.25);
      border-color: rgba(0, 0, 0, 0.5);
    }

    .amentee-popup.layout-fullscreen.text-dark .amentee-popup-close::before,
    .amentee-popup.layout-fullscreen.text-dark .amentee-popup-close::after {
      background: #000000;
    }

    .amentee-popup.layout-fullscreen .amentee-popup-content {
      position: relative;
      z-index: 1;
      padding: 60px 40px;
      max-width: 600px;
      width: 90%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }

    .amentee-popup.layout-fullscreen .amentee-popup-image {
      display: none !important;
    }

    /* Text color modes for fullscreen */
    .amentee-popup.layout-fullscreen.text-light h2,
    .amentee-popup.layout-fullscreen.text-light p,
    .amentee-popup.layout-fullscreen.text-light .amentee-popup-decline {
      color: #ffffff;
    }

    .amentee-popup.layout-fullscreen.text-light input[type="email"] {
      background: rgba(255, 255, 255, 0.9);
      border-color: #ffffff;
      color: #000000;
    }

    .amentee-popup.layout-fullscreen.text-light input[type="email"]::placeholder {
      color: rgba(0, 0, 0, 0.5) !important;
    }

    .amentee-popup.layout-fullscreen.text-light input[type="email"]:focus {
      background: rgba(255, 255, 255, 1);
    }

    .amentee-popup.layout-fullscreen.text-dark h2,
    .amentee-popup.layout-fullscreen.text-dark p,
    .amentee-popup.layout-fullscreen.text-dark .amentee-popup-decline {
      color: #2d3748;
    }

    .amentee-popup.layout-fullscreen.text-dark input[type="email"] {
      background: rgba(255, 255, 255, 0.95);
      border-color: #000000;
      color: #000000;
    }

    .amentee-popup.layout-fullscreen.text-dark input[type="email"]::placeholder {
      color: rgba(0, 0, 0, 0.4) !important;
    }

    /* ===== SHARED STYLES ===== */
    .amentee-popup-logo {
      width: 220px;
      height: auto;
      margin-bottom: 50px;
      object-fit: contain;
    }

    .amentee-popup h2 {
      font-size: 36px;
      font-weight: 700;
      font-family: Arial, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
      color: #2d3748;
      margin: 0 0 20px 0;
      line-height: 1.2;
    }

    .amentee-popup p {
      font-size: 16px;
      color: #718096;
      margin: 0 0 30px 0;
      line-height: 1.5;
    }

    /* Step subtexts and additional text */
    .amentee-popup .step1-subtext {
      font-size: 18px;
      margin: -10px 0 20px 0;
      font-weight: 500;
    }
    
    .amentee-popup .step2-text {
      font-size: 16px;
      margin: 0 0 15px 0;
    }
    
    .amentee-popup .step2-subtext {
      font-size: 14px;
      margin: -5px 0 20px 0;
      font-style: italic;
    }

    .amentee-popup-button {
      width: 100%;
      padding: 18px 40px;
      background: #000;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 24px;
      font-weight: 700;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", Arial, sans-serif;
      cursor: pointer;
      transition: all 0.2s;
      text-transform: none;
      letter-spacing: 0.5px;
    }

    .amentee-popup-button:hover {
      background: #333;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .amentee-popup-button:disabled {
      background: #999;
      cursor: not-allowed;
      transform: none;
    }

    .amentee-popup-buttons-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .amentee-popup-buttons-container.multi-choice {
      gap: 10px;
    }

    .amentee-popup-buttons-container.multi-choice .amentee-popup-button {
      padding: 14px 30px;
      font-size: 16px;
    }

    .amentee-popup input[type="email"] {
      width: 100%;
      padding: 16px 20px;
      border: 2px solid #000;
      border-radius: 4px;
      font-size: 16px;
      margin-bottom: 20px;
      box-sizing: border-box;
      transition: all 0.2s;
      background: #f8f9fa;
    }

    .amentee-popup input[type="email"]:focus {
      outline: none;
      border-color: #000;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
    }

    .amentee-popup input[type="email"]::placeholder {
      color: #6c757d;
      font-weight: 500;
    }

    .amentee-popup-decline {
      margin-top: 10px;
      color: #a0aec0;
      font-size: 16px;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", Arial, sans-serif;
      cursor: pointer;
      text-decoration: none;
      transition: color 0.2s;
      display: inline-block;
    }

    .amentee-popup-decline:hover {
      color: #718096;
      text-decoration: underline;
    }

    .amentee-popup-step {
      display: none;
      width: 100%;
    }

    .amentee-popup-step.active {
      display: block;
    }

    .amentee-popup-step.step-3 p {
      font-size: 15px;
      line-height: 1.6;
      margin-bottom: 15px;
    }

    .amentee-popup-step.step-3 p:last-child {
      font-size: 13px;
      color: #a0aec0;
    }

    .amentee-teaser {
      position: fixed;
      bottom: 20px;
      left: 20px;
      background: #000;
      color: white;
      padding: 15px 25px;
      border-radius: 4px;
      cursor: pointer;
      z-index: 999998;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      transition: all 0.2s;
      display: none;
    }

    .amentee-teaser.active {
      display: block;
      animation: slideInLeft 0.4s ease;
    }

    @keyframes slideInLeft {
      from {
        transform: translateX(-100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .amentee-teaser:hover {
      background: #333;
      transform: scale(1.05);
    }

    .amentee-teaser-text {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }

    /* ===== TEST MODE STYLES ===== */
    .amentee-test-teasers {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.95), rgba(0, 0, 0, 0.85));
      padding: 15px 20px;
      z-index: 999997;
      display: none;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: center;
      align-items: center;
      box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.3);
      border-top: 2px solid rgba(255, 255, 255, 0.2);
    }

    .amentee-test-teasers.active {
      display: flex;
    }

    .amentee-test-teaser-label {
      color: rgba(255, 255, 255, 0.6);
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-right: 10px;
    }

    .amentee-test-teaser {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 14px;
      font-weight: 600;
      border: 2px solid rgba(255, 255, 255, 0.2);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      min-width: 120px;
    }

    .amentee-test-teaser:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
      border-color: rgba(255, 255, 255, 0.5);
    }

    .amentee-test-teaser-name {
      font-size: 13px;
      font-weight: 700;
      text-align: center;
    }

    .amentee-test-teaser-id {
      font-size: 10px;
      opacity: 0.7;
      text-align: center;
    }

    .amentee-test-teaser.active-variant {
      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
      border-color: rgba(255, 255, 255, 0.8);
      box-shadow: 0 0 20px rgba(245, 87, 108, 0.5);
    }

    /* ===== RESPONSIVE ===== */
    @media (max-width: 860px) {
      .amentee-popup.layout-modal {
        flex-direction: column;
        width: 90%;
        height: auto;
        max-height: 90vh;
        overflow-y: auto;
      }

      .amentee-popup.layout-modal .amentee-popup-image {
        width: 100% !important;
        height: 250px !important;
        min-height: 250px;
        flex: none;
      }

      .amentee-popup.layout-modal .amentee-popup-content {
        padding: 40px 30px;
      }

      .amentee-popup.layout-fullscreen .amentee-popup-content {
        padding: 40px 30px;
      }

      .amentee-popup.layout-fullscreen .amentee-popup-close {
        top: 15px;
        right: 15px;
        width: 40px;
        height: 40px;
      }

      .amentee-popup.layout-fullscreen .amentee-popup-close::before,
      .amentee-popup.layout-fullscreen .amentee-popup-close::after {
        width: 18px;
      }

      .amentee-popup h2 {
        font-size: 28px;
      }

      .amentee-popup-logo {
        width: 150px;
        margin-bottom: 25px;
      }

      .amentee-teaser {
        bottom: 10px;
        left: 10px;
        padding: 12px 20px;
        font-size: 14px;
      }
    }
  `;
  document.head.appendChild(style);

  // Helper function to generate inline style attribute
  function getInlineStyle(color) {
    return color && color.trim() !== '' ? ` style="color: ${color} !important;"` : '';
  }
  
  function getInlineBackgroundStyle(color) {
    return color && color.trim() !== '' ? ` style="background-color: ${color} !important;"` : '';
  }
  
  function getInlineBorderColorStyle(color) {
    return color && color.trim() !== '' ? ` style="border-color: ${color} !important;"` : '';
  }
  
  function getButtonStyles(config) {
    const styles = [];
    if (config.buttonColor && config.buttonColor.trim()) {
      styles.push(`background-color: ${config.buttonColor} !important`);
    }
    if (config.buttonTextColor && config.buttonTextColor.trim()) {
      styles.push(`color: ${config.buttonTextColor} !important`);
    }
    return styles.length > 0 ? ` style="${styles.join('; ')};"` : '';
  }
  
  function getSubmitButtonStyles(config) {
    const styles = [];
    // Use submit-specific colors, fallback to regular button colors
    const bgColor = config.submitButtonColor || config.buttonColor;
    const textColor = config.submitButtonTextColor || config.buttonTextColor;
    
    if (bgColor && bgColor.trim()) {
      styles.push(`background-color: ${bgColor} !important`);
    }
    if (textColor && textColor.trim()) {
      styles.push(`color: ${textColor} !important`);
    }
    return styles.length > 0 ? ` style="${styles.join('; ')};"` : '';
  }
  
  function getEmailInputStyles(config) {
    const styles = [];
    if (config.emailInputBorderColor && config.emailInputBorderColor.trim()) {
      styles.push(`border-color: ${config.emailInputBorderColor} !important`);
    }
    if (config.emailInputTextColor && config.emailInputTextColor.trim()) {
      styles.push(`color: ${config.emailInputTextColor} !important`);
    }
    return styles.length > 0 ? ` style="${styles.join('; ')};"` : '';
  }
  
  function getTeaserStyles(config) {
    const styles = [];
    if (config.teaserBackgroundColor && config.teaserBackgroundColor.trim()) {
      styles.push(`background: ${config.teaserBackgroundColor} !important`);
    }
    if (config.teaserTextColor && config.teaserTextColor.trim()) {
      styles.push(`color: ${config.teaserTextColor} !important`);
    }
    return styles.length > 0 ? ` style="${styles.join('; ')};"` : '';
  }

  function generatePopupHTML(variant) {
    const config = variant.config;
    const isFullscreen = config.layoutType === 'fullscreen';
    const textModeClass = isFullscreen ? `text-${config.textMode}` : '';
    
    const buttonTexts = config.buttonTexts || [config.buttonText || 'Continue'];
    const validButtons = buttonTexts.filter(text => text && text.trim() !== '');
    const isMultiChoice = validButtons.length > 1;
    
    // Generate buttons with custom colors
    const buttonsHTML = validButtons.map((text, index) => {
      const buttonStyles = getButtonStyles(config);
      return `<button class="amentee-popup-button step1-button" data-button-index="${index}"${buttonStyles}>${text}</button>`;
    }).join('');
    
    // Modal layout: includes side image
    // Fullscreen layout: no side image, background set via CSS
    const imageHTML = isFullscreen ? '' : `<div class="amentee-popup-image" style="background-image: url('${config.productImageUrl}');"></div>`;
    
    // Close button only for fullscreen
    const closeButtonHTML = isFullscreen ? `<div class="amentee-popup-close" id="amenteeClose" title="Close"></div>` : '';
    
    // Get inline styles for text elements
    const step1HeadlineStyle = getInlineStyle(config.step1HeadlineColor);
    const step1SubtextStyle = getInlineStyle(config.step1SubtextColor);
    const step2HeadlineStyle = getInlineStyle(config.step2HeadlineColor);
    const step2TextStyle = getInlineStyle(config.step2TextColor);
    const step2SubtextStyle = getInlineStyle(config.step2SubtextColor);
    const step3HeadlineStyle = getInlineStyle(config.step3HeadlineColor);
    const step3TextStyle = getInlineStyle(config.step3TextColor);
    const step3SubTextStyle = getInlineStyle(config.step3SubTextColor);
    const declineTextStyle = getInlineStyle(config.declineTextColor);
    const submitButtonStyles = getSubmitButtonStyles(config);
    const emailInputStyles = getEmailInputStyles(config);
    const teaserStyles = getTeaserStyles(config);
    
    return `
      <div class="amentee-popup-overlay" id="amenteePopup">
        <div class="amentee-popup layout-${config.layoutType} ${textModeClass}" id="amenteePopupContainer">
          ${closeButtonHTML}
          ${imageHTML}
          
          <div class="amentee-popup-content">
            <img src="${config.logoUrl}" alt="Logo" class="amentee-popup-logo">
            
            <div class="amentee-popup-step step-1 active">
              <h2${step1HeadlineStyle}>${config.step1Headline}</h2>
              ${config.step1Subtext ? `<p class="step1-subtext"${step1SubtextStyle}>${config.step1Subtext}</p>` : ''}
              <div class="amentee-popup-buttons-container ${isMultiChoice ? 'multi-choice' : ''}">
                ${buttonsHTML}
              </div>
              <a href="#" class="amentee-popup-decline" id="decline1"${declineTextStyle}>${config.declineText}</a>
            </div>

            <div class="amentee-popup-step step-2">
              <h2${step2HeadlineStyle}>${config.step2Headline}</h2>
              ${config.step2Text ? `<p class="step2-text"${step2TextStyle}>${config.step2Text}</p>` : ''}
              ${config.step2Subtext ? `<p class="step2-subtext"${step2SubtextStyle}>${config.step2Subtext}</p>` : ''}
              <form id="amenteeEmailForm">
                <input 
                  type="email" 
                  name="field-0" 
                  id="amenteeEmail"
                  placeholder="${config.emailPlaceholder}" 
                  required
                  autocomplete="email"${emailInputStyles}
                >
                <button type="submit" class="amentee-popup-button"${submitButtonStyles}>${config.submitText}</button>
              </form>
              <a href="#" class="amentee-popup-decline" id="decline2"${declineTextStyle}>${config.declineText}</a>
            </div>

            <div class="amentee-popup-step step-3">
              <h2${step3HeadlineStyle}>${config.step3Headline}</h2>
              <p${step3TextStyle}>${config.step3Text}</p>
              <p${step3SubTextStyle}>${config.step3SubText}</p>
              <button class="amentee-popup-button" id="successClose" style="margin-top: 20px;">Continue Shopping</button>
            </div>
          </div>
        </div>
      </div>

      <div class="amentee-teaser" id="amenteeTeaser"${teaserStyles}>
        <div class="amentee-teaser-text">${config.teaserText}</div>
      </div>
    `;
  }

  // Generate test mode teasers for all variants
  function generateTestTeasersHTML(variants, currentVariantId) {
    const teasersHTML = variants.map(variant => {
      const isActive = variant.id === currentVariantId;
      const activeClass = isActive ? 'active-variant' : '';
      return `
        <div class="amentee-test-teaser ${activeClass}" data-variant-id="${variant.id}">
          <div class="amentee-test-teaser-name">${variant.name}</div>
          <div class="amentee-test-teaser-id">${variant.id}</div>
        </div>
      `;
    }).join('');
    
    return `
      <div class="amentee-test-teasers active" id="amenteeTestTeasers">
        <div class="amentee-test-teaser-label">🧪 Test Mode - Click to Preview:</div>
        ${teasersHTML}
      </div>
    `;
  }

  // Show a specific variant by ID (for test mode)
  function showVariantById(variantId) {
    // Store selected variant and reload page to show it
    sessionStorage.setItem(variantIdKey, variantId);
    sessionStorage.removeItem(storageKey); // Allow popup to show again
    sessionStorage.removeItem(completedKey);
    window.location.reload();
  }

  // Update test teaser visual states
  function updateTestTeaserStates(activeVariantId) {
    const testTeasers = document.querySelectorAll('.amentee-test-teaser');
    testTeasers.forEach(teaser => {
      const variantId = teaser.getAttribute('data-variant-id');
      if (variantId === activeVariantId) {
        teaser.classList.add('active-variant');
      } else {
        teaser.classList.remove('active-variant');
      }
    });
  }

  function showTeaser(variant) {
    if (document.getElementById('amenteeTeaser')) {
      return;
    }
    
    const teaserHTML = `
      <div class="amentee-teaser active" id="amenteeTeaser">
        <div class="amentee-teaser-text">${variant.config.teaserText}</div>
      </div>
    `;
    
    const container = document.createElement('div');
    container.innerHTML = teaserHTML;
    document.body.appendChild(container.firstElementChild);
    
    const teaserElement = document.getElementById('amenteeTeaser');
    if (teaserElement) {
      teaserElement.addEventListener('click', () => {
        storage.removeItem(storageKey);
        storage.removeItem(completedKey);
        storage.setItem(forcePopupKey, 'true');
        window.location.reload();
      });
    }
  }

  function getShopifyCustomerIdFast() {
    try {
      const id = window?.ShopifyAnalytics?.meta?.page?.customerId;
      return id ? String(id) : null;
    } catch (_) {
      return null;
    }
  }

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise((resolve) => setTimeout(() => resolve(null), ms)),
    ]);
  }

  async function isLoggedInCustomer() {
    const cid = getShopifyCustomerIdFast();
    if (cid) return true;

    // Skip fallback check if disabled (prevents CORS errors on account subdomains)
    if (!CONFIG.accountCheckTimeoutMs || CONFIG.accountCheckTimeoutMs === 0) {
      return false;
    }

    try {
      const res = await withTimeout(
        fetch('/account', {
          method: 'GET',
          credentials: 'include',
          cache: 'no-store',
          redirect: 'follow',
          headers: { 'Accept': 'text/html' }
        }),
        CONFIG.accountCheckTimeoutMs
      );

      if (!res) return false;
      const finalUrl = (res.url || '').toLowerCase();
      if (finalUrl.includes('/account/login')) return false;
      if (res.ok) return true;
      return false;
    } catch (_) {
      // CORS errors (account subdomain redirects) are caught here
      // This is expected behavior - we assume user is not logged in
      return false;
    }
  }

  function isPageExcluded() {
    const currentPath = window.location.pathname.toLowerCase();
    
    // WHITELIST MODE: If includedPages has values, ONLY show on those pages
    if (CONFIG.includedPages && CONFIG.includedPages.length > 0) {
      const isIncluded = CONFIG.includedPages.some(includedPath => {
        const normalizedIncluded = includedPath.toLowerCase();
        
        // Exact match
        if (currentPath === normalizedIncluded) {
          return true;
        }
        
        // Starts with match (for /collections/sale matching /collections/sale/page-2)
        if (currentPath.startsWith(normalizedIncluded)) {
          return true;
        }
        
        return false;
      });
      
      // If page is NOT in included list, exclude it
      return !isIncluded;
    }
    
    // BLACKLIST MODE: Use excludedPages (normal mode)
    return CONFIG.excludedPages.some(excludedPath => {
      const normalizedExcluded = excludedPath.toLowerCase();
      
      // Exact match
      if (currentPath === normalizedExcluded) {
        return true;
      }
      
      // Starts with match
      if (currentPath.startsWith(normalizedExcluded)) {
        return true;
      }
      
      return false;
    });
  }

  async function init() {
    if (detectBot()) {
      console.log('Bot detected, exiting');
      return;
    }

    if (isPageExcluded()) {
      console.log('Page excluded from popup:', window.location.pathname);
      return;
    }

    let loginCheckPromise = null;
    if (CONFIG.suppressForLoggedInCustomers) {
      loginCheckPromise = isLoggedInCustomer();
    }

    let selectedVariant = getVariantFast();
    
    if (!selectedVariant) {
      const eligibleVariants = await getEligibleVariants();
      selectedVariant = selectVariant(eligibleVariants);
      console.log('Selected variant (from API):', selectedVariant.name, '(' + selectedVariant.id + ')');
    } else {
      console.log('Using cached variant:', selectedVariant.name, '(' + selectedVariant.id + ')');
    }

    if (loginCheckPromise) {
      const loggedIn = await loginCheckPromise;
      if (loggedIn) {
        console.log('Logged in customer, skipping popup');
        return;
      }
    }

    const shouldForcePopup = storage.getItem(forcePopupKey);
    
    if (shouldForcePopup) {
      storage.removeItem(forcePopupKey);
    } else if (storage.getItem(storageKey)) {
      if (!storage.getItem(completedKey)) {
        showTeaser(selectedVariant);
      }
      return;
    }
    
    const container = document.createElement('div');
    container.innerHTML = generatePopupHTML(selectedVariant);
    while (container.firstChild) {
      document.body.appendChild(container.firstChild);
    }

    const popup = document.getElementById('amenteePopup');
    const popupContainer = document.getElementById('amenteePopupContainer');
    const step1Buttons = document.querySelectorAll('.step1-button');
    const decline1 = document.getElementById('decline1');
    const decline2 = document.getElementById('decline2');
    const form = document.getElementById('amenteeEmailForm');
    const teaser = document.getElementById('amenteeTeaser');
    const successClose = document.getElementById('successClose');
    const closeButton = document.getElementById('amenteeClose');

    if (!popup || step1Buttons.length === 0 || !decline1 || !decline2 || !form || !teaser) {
      return;
    }

    // TEST MODE: Inject test teasers for all variants
    if (CONFIG.testMode) {
      const testTeasersHTML = generateTestTeasersHTML(CONFIG.variants, selectedVariant.id);
      const testContainer = document.createElement('div');
      testContainer.innerHTML = testTeasersHTML;
      document.body.appendChild(testContainer.firstElementChild);

      // Add click handlers to test teasers
      const testTeasers = document.querySelectorAll('.amentee-test-teaser');
      testTeasers.forEach(teaser => {
        teaser.addEventListener('click', () => {
          const variantId = teaser.getAttribute('data-variant-id');
          if (variantId) {
            // Set variant and reload to show it
            sessionStorage.setItem(variantIdKey, variantId);
            sessionStorage.removeItem(storageKey); // Allow popup to show again
            sessionStorage.removeItem(completedKey);
            window.location.reload();
          }
        });
      });

      console.log('🧪 Test Mode enabled - Click teasers at bottom to preview variants');
    }

    // Set fullscreen background image based on device
    if (selectedVariant.config.layoutType === 'fullscreen' && popupContainer) {
      const isMobile = window.innerWidth <= 860;
      const bgImage = isMobile ? selectedVariant.config.backgroundImageMobile : selectedVariant.config.backgroundImageDesktop;
      popupContainer.style.backgroundImage = `url('${bgImage}')`;
    }

    // Apply custom hover effects if buttonHoverColor is specified
    if (selectedVariant.config.buttonHoverColor && selectedVariant.config.buttonHoverColor.trim()) {
      const allButtons = document.querySelectorAll('.amentee-popup-button');
      const hoverColor = selectedVariant.config.buttonHoverColor;
      const originalColor = selectedVariant.config.buttonColor || '';
      
      allButtons.forEach(button => {
        // Store original background color
        const originalBg = button.style.backgroundColor || originalColor;
        
        button.addEventListener('mouseenter', () => {
          button.style.backgroundColor = hoverColor + ' !important';
        });
        
        button.addEventListener('mouseleave', () => {
          if (originalBg) {
            button.style.backgroundColor = originalBg;
          } else {
            button.style.backgroundColor = '';
          }
        });
      });
    }

    let formCompleted = false;
    let triggerType = 'delay';

    function goToStep(stepNumber) {
      document.querySelectorAll('.amentee-popup-step').forEach(step => {
        step.classList.remove('active');
      });
      const targetStep = document.querySelector(`.amentee-popup-step.step-${stepNumber}`);
      if (targetStep) {
        targetStep.classList.add('active');
      }
    }

    function closePopup(showTeaserAfter = true) {
      popup.classList.remove('active');
      document.body.style.overflow = '';
      
      if (showTeaserAfter && !formCompleted) {
        teaser.classList.add('active');
      }
    }

    function showPopupNow(trigger) {
      triggerType = trigger;
      popup.classList.add('active');
      storage.setItem(storageKey, 'true');
      document.body.style.overflow = 'hidden';
      
      trackEvent('popup_impression', {
        trigger_type: trigger,
        logged_in_status: 'visitor',
        variant_name: selectedVariant.name,
        layout_type: selectedVariant.config.layoutType
      });
    }

    let delayTimer = null;
    
    // TEST MODE: Show popup immediately, no delay
    if (CONFIG.testMode) {
      showPopupNow('test_mode');
    } else if (shouldForcePopup) {
      showPopupNow('teaser_reopen');
    } else {
      delayTimer = setTimeout(() => {
        if (!teaser.classList.contains('active')) {
          showPopupNow('delay');
        }
      }, CONFIG.delaySeconds * 1000);
    }

    step1Buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        trackHumanInteraction();
        const buttonText = button.textContent;
        const buttonIndex = button.getAttribute('data-button-index');
        
        trackEvent('step_1_button_click', {
          variant_name: selectedVariant.name,
          button_text: buttonText,
          button_index: buttonIndex,
          layout_type: selectedVariant.config.layoutType
        });
        
        goToStep(2);
      });
    });
    
    decline1.addEventListener('click', (e) => { 
      e.preventDefault();
      trackEvent('decline_step_1', { 
        trigger_type: triggerType,
        variant_name: selectedVariant.name,
        layout_type: selectedVariant.config.layoutType
      });
      closePopup(true);
    });
    
    decline2.addEventListener('click', (e) => { 
      e.preventDefault();
      trackEvent('decline_step_2', { 
        trigger_type: triggerType,
        variant_name: selectedVariant.name,
        layout_type: selectedVariant.config.layoutType
      });
      closePopup(true);
    });

    if (successClose) {
      successClose.addEventListener('click', () => {
        closePopup(false);
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        trackEvent('close_button_click', {
          trigger_type: triggerType,
          variant_name: selectedVariant.name,
          layout_type: selectedVariant.config.layoutType
        });
        closePopup(true);
      });
    }

    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        closePopup(true);
      }
    });

    teaser.addEventListener('click', () => {
      formCompleted = false;
      popup.classList.add('active');
      goToStep(1);
      document.body.style.overflow = 'hidden';
      teaser.classList.remove('active');
    });

    if (CONFIG.exitIntent && !shouldForcePopup) {
      let exitIntentTriggered = false;
      
      const handleExitIntent = (e) => {
        if (window.innerWidth < 768) return;
        
        if (e.clientY <= 0 && !exitIntentTriggered) {
          if (!popup.classList.contains('active') && !teaser.classList.contains('active') && !formCompleted) {
            exitIntentTriggered = true;
            
            if (delayTimer) {
              clearTimeout(delayTimer);
            }
            
            showPopupNow('exit_intent');
            document.removeEventListener('mouseout', handleExitIntent);
          }
        }
      };
      
      document.addEventListener('mouseout', handleExitIntent);
    }

    if (CONFIG.scrollPercent > 0 && !shouldForcePopup) {
      let scrollTriggered = false;
      
      const handleScroll = () => {
        if (scrollTriggered) return;
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;
        
        if (scrollPercent >= CONFIG.scrollPercent) {
          if (!popup.classList.contains('active') && !teaser.classList.contains('active') && !formCompleted) {
            scrollTriggered = true;
            
            if (delayTimer) {
              clearTimeout(delayTimer);
            }
            
            showPopupNow('scroll_' + Math.round(scrollPercent) + '%');
            window.removeEventListener('scroll', handleScroll);
          }
        }
      };
      
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      trackHumanInteraction();
      
      const submitBtn = form.querySelector('button[type="submit"]');
      const emailInput = document.getElementById('amenteeEmail');
      
      console.log('=== FORM SUBMISSION DEBUG ===');
      console.log('Email input element:', emailInput);
      console.log('Email input value:', emailInput ? emailInput.value : 'INPUT NOT FOUND');
      console.log('Email input name attr:', emailInput ? emailInput.getAttribute('name') : 'N/A');
      
      const email = emailInput ? emailInput.value : '';
      
      // Validate email
      if (!email || !emailInput.validity.valid) {
        alert('Please enter a valid email address.');
        return;
      }
      
      console.log('Email to submit:', email);
      
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';

      try {
        // Create FormData and append email with correct field name (field-0 as per PodAutomate form)
        const formData = new FormData();
        formData.append('field-0', email);
        
        console.log('FormData created');
        console.log('FormData entries:', Array.from(formData.entries()));
        console.log('FormData has email:', formData.has('email'));
        console.log('FormData get email:', formData.get('email'));
        
        // Submit to PodAutomate form (multipart/form-data)
        const response = await fetch(CONFIG.formSubmitUrl, {
          method: 'POST',
          body: formData  // Browser automatically sets Content-Type: multipart/form-data
        });

        console.log('Response status:', response.status);
        console.log('Response ok:', response.ok);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Submission error:', errorText);
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Track successful submission in analytics
        trackEvent('form_submission', {
          email: email,
          trigger_type: triggerType,
          logged_in_status: 'visitor',
          variant_name: selectedVariant.name,
          layout_type: selectedVariant.config.layoutType
        });

        formCompleted = true;
        storage.setItem(completedKey, 'true');
        goToStep(3);

      } catch (error) {
        console.error('Form submission error:', error);
        trackEvent('form_error', {
          error: error.message,
          trigger_type: triggerType,
          variant_name: selectedVariant.name,
          layout_type: selectedVariant.config.layoutType
        });
        alert('Something went wrong. Please try again.');
        submitBtn.disabled = false;
        submitBtn.textContent = selectedVariant.config.submitText;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();